export default function () {
    const selectors = {
        main: '.b-header',
        menuBtn: '.b-header__menu-btn',
    };

    const classes = {
        menuOpened: 'b-header_mobile-menu-opened',
        sticky: 'b-header_sticky',
        bodyOverflow: 'b-page_menu-opened',
        maySticky: 'b-header_may-sticky',
    };

    $(`${selectors.main}.js-init`).each((i, elem) => {
        initHeader($(elem));
    });

    function initHeader($elem) {
        const elems = {
            $main: $elem,
            $menuBtn: $elem.find(selectors.menuBtn)
        };

        elems.$menuBtn.click(() => {
            elems.$main.toggleClass(classes.menuOpened);
            $('body').toggleClass(classes.bodyOverflow);
        });

        handleStiky(elems)
    }

    function handleStiky(elems) {
        $(document).scroll((e) => {
            const headerHeight = elems.$main.height();
            const scrollPos = $(document).scrollTop();

            if(elems.$main.hasClass(classes.maySticky)) {
                if (scrollPos > headerHeight) {
                    elems.$main.addClass(classes.sticky);
                } else {
                    elems.$main.removeClass(classes.sticky);
                }
            }
        })
    }
}
